/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification } from './FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification';
import {
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationFromJSON,
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationFromJSONTyped,
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationToJSON,
} from './FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification';
import type { FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner } from './FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner';
import {
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerFromJSON,
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerFromJSONTyped,
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerToJSON,
} from './FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner';

/**
 *
 * @export
 * @interface FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner
 */
export interface FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner {
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner
     */
    practitioner_id: string;
    /**
     *
     * @type {Date}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner
     */
    updated_at: Date;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner
     */
    role: FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerRoleEnum;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner
     */
    effective_date?: string | null;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner
     */
    source_document?: string | null;
    /**
     *
     * @type {FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner
     */
    practitioner: FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitioner;
    /**
     *
     * @type {FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner
     */
    pecos_verification?: FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification;
    /**
     *
     * @type {string}
     * @memberof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner
     */
    last_checked_at: string | null;
}


/**
 * @export
 */
export const FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerRoleEnum = {
    InitialReferring: 'INITIAL_REFERRING',
    F2FEncounter: 'F2F_ENCOUNTER',
    F2FCertifying: 'F2F_CERTIFYING',
    PlanOfCareSigning: 'PLAN_OF_CARE_SIGNING'
} as const;
export type FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerRoleEnum = typeof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerRoleEnum[keyof typeof FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerRoleEnum];


/**
 * Check if a given object implements the FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner interface.
 */
export function instanceOfFindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "practitioner_id" in value;
    isInstance = isInstance && "updated_at" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "practitioner" in value;
    isInstance = isInstance && "last_checked_at" in value;

    return isInstance;
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerFromJSON(json: any): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner {
    return FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerFromJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'id': json['id'],
        'practitioner_id': json['practitioner_id'],
        'updated_at': (new Date(json['updated_at'])),
        'role': json['role'],
        'effective_date': !exists(json, 'effective_date') ? undefined : json['effective_date'],
        'source_document': !exists(json, 'source_document') ? undefined : json['source_document'],
        'practitioner': FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerFromJSON(json['practitioner']),
        'pecos_verification': !exists(json, 'pecos_verification') ? undefined : FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationFromJSON(json['pecos_verification']),
        'last_checked_at': json['last_checked_at'],
    };
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerToJSON(value?: FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'id': value.id,
        'practitioner_id': value.practitioner_id,
        'updated_at': (value.updated_at.toISOString()),
        'role': value.role,
        'effective_date': value.effective_date,
        'source_document': value.source_document,
        'practitioner': FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPractitionerToJSON(value.practitioner),
        'pecos_verification': FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationToJSON(value.pecos_verification),
        'last_checked_at': value.last_checked_at,
    };
}
